module.exports = __webpack_public_path__ + "img/sez-bg.5e3e4ece.png";